/**
 * @file transportAutofill.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-30
 * @modified 2026-09-30
 * @description What choosing a driver or a haulier fills in with it — ONE rule,
 *              used by the planning boards, the PO editor's Transport cell and
 *              Add/Update Supplied Qty, so the same choice gives the same
 *              result wherever it is made.
 *
 *   A driver brings their haulier (when they have exactly one) and their
 *   default vehicle; with no default vehicle, an outside haulier's driver gets
 *   the "Unknown" vehicle (payload set later) and ours gets none.
 *   A haulier brings the driver of the same name (the owner-driver).
 *
 * `drivers` are the records from /api/transport/drivers: { name, hauliers:
 * [{ name }], default_vehicle_registration }. Returns only the fields the
 * choice changes; the caller merges them in and saves them together.
 */

import { UNKNOWN_VEHICLE, isExcelHaulier } from './planningRows';

export function driverChanges(driver, drivers = [], currentHaulier = '') {
  const changes = { driver: driver || '' };
  if (!driver) return changes;
  const record = drivers.find(d => d.name === driver);
  const linked = record?.hauliers || [];
  if (linked.length === 1) changes.haulier = linked[0].name;
  if (record?.default_vehicle_registration) {
    changes.vehicle = record.default_vehicle_registration;
  } else {
    const haulier = changes.haulier || currentHaulier || '';
    if (haulier && !isExcelHaulier(haulier)) changes.vehicle = UNKNOWN_VEHICLE;
  }
  return changes;
}

export function haulierChanges(haulier, drivers = []) {
  const changes = { haulier: haulier || '' };
  const owner = haulier
    ? drivers.find(d => d.name.trim().toLowerCase() === haulier.trim().toLowerCase())
    : null;
  if (owner) changes.driver = owner.name;
  return changes;
}
